import React, { createContext, useCallback, useState } from 'react';
import { notificationsConfig as config } from '../../shared/constants';

export const NotificationModeStateContext = createContext();
export const NotificationModeDispatchContext = createContext();

export const NotificationModeProvider = ({ initMode, children }) => {
  const [mode, setMode] = useState(initMode || config.all.name);

  const changeMode = useCallback((mode) => setMode(mode), []);

  return (
    <NotificationModeStateContext.Provider value={mode}>
      <NotificationModeDispatchContext.Provider value={changeMode}>
        {children}
      </NotificationModeDispatchContext.Provider>
    </NotificationModeStateContext.Provider>
  );
};
